// extracted by mini-css-extract-plugin
module.exports = {"defaultWrapText":"TextWordBreakWrapper_defaultWrapText__PzPKc","asianWrapText":"TextWordBreakWrapper_asianWrapText__FCfSo"};